import { ComponentWithAs, Icon, IconProps } from '@chakra-ui/react'

const IconComp: ComponentWithAs<'svg', IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon fill="none" {...props}>
      <mask id="path-1-inside-1_2887_5899" fill="white">
        <rect x="2" y="4" width="20" height="16" rx="1"></rect>
      </mask>
      <rect
        x="2"
        y="4"
        width="20"
        height="16"
        rx="1"
        stroke="#FFFFFF"
        strokeWidth="4"
        mask="url(#path-1-inside-1_2887_5899)"
      ></rect>
      <path
        d="M13 9C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11V9ZM15 11C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9V11ZM13 11H15V9H13V11Z"
        fill="#FFFFFF"
      ></path>
      <path
        d="M13 13C12.4477 13 12 13.4477 12 14C12 14.5523 12.4477 15 13 15V13ZM17 15C17.5523 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13V15ZM13 15H17V13H13V15Z"
        fill="#FFFFFF"
      ></path>
      <circle cx="8.5625" cy="10.5625" r="1.5625" fill="#FFFFFF"></circle>
      <path
        d="M10.7342 14.3583C9.64762 12.2139 7.35238 12.2139 6.2658 14.3583C6.11154 14.6627 6.35243 15 6.69371 15H10.3063C10.6476 15 10.8885 14.6627 10.7342 14.3583Z"
        fill="#FFFFFF"
      ></path>
    </Icon>
  )
}
IconComp.defaultProps = {
  viewBox: '0 0 24 24',
  boxSize: '24px',
}

export default IconComp
